import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Box,
  Collapse,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { IconReportSearch } from "@tabler/icons-react";
import { useCallback, useRef, useState } from "react";
import Documents from "./Documents";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
import SearchField from "../../components/inputs/SearchField";
import { debounce } from "lodash";

const Content = ({ search, setSearch, cases, isLoading }: any) => {
  // const [search, setSearch] = useState<string>("");
  // const { cases, isLoading } = useCases(
  //   undefined,
  //   search,
  //   { page: 0, pageSize: 12 },
  //   [{ field: "createdAt", sort: "desc" }],
  //   false,
  //   [
  //     [
  //       { title: "Active" },
  //       { title: "Prospect" },
  //       { title: "InReview" },
  //       { title: "Retained" },
  //       { title: "UnRetained" },
  //     ],
  //   ]
  // );
  const options = [
    { title: "All Documents", value: "uploadedDocuments" },
    { title: "Chat Documents", value: "chatDocuments" },
    { title: "Rep Agreement", value: "repAgreement" },
    { title: "DPS Report", value: "report" },
  ];

  const [expandedCategory, setExpandedCategory] = useState<string | null>(null);
  const [selectedValue, setSelectedValue] = useState(options[0]?.value); // Set initial value to the first option

  const handleToggle = (title: string) => {
    setExpandedCategory((prev) => (prev === title ? null : title));
    setSelectedValue(options[0]?.value);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };
  const selectedCase = cases?.find(
    (item: any) => item.caseId === expandedCategory
  );
  const selectedOption = options?.find(
    (option) => option.value === selectedValue
  );

  // Add debounce to hold render events
  const debouncedSetSearch = useRef(
    debounce((value) => setSearch(value), 400)
  ).current;

  const handleSearchChange = useCallback(
    (event: any) => {
      debouncedSetSearch(event.target.value.trim());
    },
    [debouncedSetSearch]
  );

  // if (isLoading) {
  //   return <TableSkeleton />;
  // }
  return (
    <Stack
      direction={"row"}
      justifyContent={"center"}
      sx={{
        backgroundColor: "grey.100",
        height: "calc(100vh - 220px)",
      }}
    >
      {/* Sidebar */}
      <Stack
        margin={1}
        spacing={2}
        width={window.innerWidth <= 1440 ? "32%" : "25%"}
        borderRadius="10px"
        sx={{
          backgroundColor: "white",
          padding: 1,
        }}
      >
        <SearchField
          fullWidth
          // value={search}
          onChange={handleSearchChange}
          size="small"
          placeholder="Search by inmate name or case Id"
        />
        {isLoading ? (
          <TableSkeleton />
        ) : cases?.length > 0 ? (
          <Box
            sx={{
              height: "calc(100vh - 253px)",
              overflowY: "auto",
            }}
          >
            {cases?.map((item: any) => (
              <Box key={item?._id} sx={{ mb: 1 }} mr={0.5}>
                {/* Header */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "8px 16px",
                    border: "1px solid lightgray",
                    // backgroundColor: "#f5f5f5",

                    borderRadius: "12px",
                    cursor: "pointer",
                    boxShadow: 1,
                  }}
                  onClick={() => handleToggle(item.caseId)}
                >
                  {/* <Stack direction={"row"} justifyContent={"space-between"}> */}
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      sx={{
                        color:
                          expandedCategory === item?.caseId ? "#008EBB" : "",
                      }}
                    >
                      {item?.contact?.inmate?.name ? (
                        window?.innerWidth < 900 ? (
                          item.contact.inmate.name.slice(0, 10) + "..."
                        ) : (
                          item?.contact?.inmate?.name
                        )
                      ) : (
                        // <Stack direction={"row"} alignItems={"center"}>
                        //  {item?.caseId}
                        <Typography
                          variant="body1"
                          fontWeight="bold"
                          sx={{
                            color:
                              expandedCategory === item?.caseId
                                ? "#008EBB"
                                : "",
                          }}
                        >
                          County Inmate
                        </Typography>
                        // </Stack>
                      )}
                    </Typography>
                    <Typography fontSize={"12px"}>({item?.caseId})</Typography>
                  </Box>

                  <IconButton size="small" sx={{ ml: "auto" }}>
                    {expandedCategory === item.caseId ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </IconButton>
                  {/* </Stack> */}
                </Box>

                {/* Collapsible Content */}
                <Collapse in={expandedCategory === item?.caseId}>
                  <FormControl component="fieldset" sx={{ ml: 2 }}>
                    <RadioGroup value={selectedValue} onChange={handleChange}>
                      {options?.map((option: any, index: any) => (
                        <FormControlLabel
                          key={index}
                          value={option?.value}
                          control={<Radio color="error" />}
                          label={option?.title}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </Collapse>
              </Box>
            ))}
          </Box>
        ) : (
          <Stack
            sx={{
              justifyContent: "center",
              height: "calc(100vh - 420px)",
            }}
          >
            <Typography textAlign={"center"}>{"No data found"}</Typography>
          </Stack>
        )}
      </Stack>

      <Box
        minWidth={window?.innerWidth < 1000 ? "63%" : "70%"}
        maxWidth={window?.innerWidth < 1000 ? "63%" : "70%"}
        display="flex"
        flexDirection="column"
        margin={1}
        borderRadius="10px"
        sx={{ backgroundColor: "white" }}
      >
        {/* <Paper
          elevation={1}
          square
          sx={{
            padding: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "none",
            borderRadius: "10px 10px 0px 0px",
          }}
        >
          <Typography variant={"h4"}>{selectedOption?.title}</Typography>
        </Paper> */}
        {expandedCategory ? (
          <Documents
            selectedCase={selectedCase}
            selectedOption={selectedOption}
          />
        ) : (
          <Box
            flex={1}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <IconReportSearch size={"100px"} color="grey" />
          </Box>
        )}
      </Box>
    </Stack>
  );
};

export default Content;
